import axios from "axios"
import Swal from "sweetalert2"
import { itemsPerPage } from "./global-actions-data"
import { getFormattedHeaders } from "./global-actions"

const apiUrl = process.env.REACT_APP_API_URL

// Error handler utility
const handleApiError = (
  error,
  defaultMessage = "Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador."
) => {
  if (error.response) {
    if (error.response.status === 400) {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: error.response.data.message || defaultMessage,
      })
    } else {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: defaultMessage,
      })
    }
  } else if (error.request) {
    console.log(error.request)
    Swal.fire({
      title: "¡Error!",
      confirmButtonColor: "#76b4ff",
      text: defaultMessage,
    })
  } else {
    console.log("Error", error.message)
    Swal.fire({
      title: "¡Error!",
      confirmButtonColor: "#76b4ff",
      text: defaultMessage,
    })
  }
}

export const updateRequest = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.put(
      `${apiUrl}/property/update-request/${data.data._id}`,
      data,
      {
        headers: {
          token,
        },
      }
    )

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const createContract = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.put(
      `${apiUrl}/property/create-contract/${data._id}`,
      data,
      {
        headers: {
          token,
        },
      }
    )

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getContracts = async (skip, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/property/get-contracts`, {
      headers: {
        token,
      },
      params: {
        skip,
        limit: itemsPerPage,
      },
    })

    const headersNeeded = ["totalitems", "totalpages", "currentpage"]
    const headers = getFormattedHeaders(result.headers, headersNeeded)
    const response = { data: result.data, headers }

    return response
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const createPayment = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.put(
      `${apiUrl}/property/create-payment/${data._id}`,
      data,
      {
        headers: {
          token,
        },
      }
    )

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getAwaitingRequests = async (skip, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/property/get-awaiting-requests`, {
      headers: {
        token,
      },
      params: {
        skip,
        limit: itemsPerPage,
      },
    })

    const headersNeeded = ["totalitems", "totalpages", "currentpage"]
    const headers = getFormattedHeaders(result.headers, headersNeeded)
    const response = { data: result.data, headers }

    return response
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getContractsIncrease = async (skip, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(
      `${apiUrl}/property/get-contracts-increase`,
      {
        headers: {
          token,
        },
        params: {
          skip,
          limit: itemsPerPage,
        },
      }
    )

    const headersNeeded = ["totalitems", "totalpages", "currentpage"]
    const headers = getFormattedHeaders(result.headers, headersNeeded)
    const response = { data: result.data, headers }

    return response
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getAprobedApply = async (id, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/request/approbed-apply/${id}`, {
      headers: {
        token,
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getPayments = async (contract, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/payment/${contract}`, {
      headers: {
        token,
      },
    })

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}
